/**
 * Histopathology Credit Settlement – Corporate Provider (dummy screen).
 */
import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function CorporateProvider() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" color="text.secondary">Histopathology – Corporate Provider</Typography>
    </Box>
  );
}
